import extraPieceCatalog from "./pieceCatalogExtras.json";
import { getConfiguredPieceSize, isPieceActive } from "./pieceMetadata";

export const LAYER = {
  BACKGROUND: "background",
  CENTER: "center",
  FOREGROUND: "foreground"
};

export const LAYER_ORDER = [LAYER.BACKGROUND, LAYER.CENTER, LAYER.FOREGROUND];

export const BACKGROUND_PIECES = [
  "Empty",
  "Grass_0",
  "Grass_1",
  "FireTile_0",
  "FireTile_1",
  "FireTile_2",
  "HauntedTile_0",
  "StaticField_1"
];

export const FOREGROUND_PIECES = [
  "Empty",
  "Honey_0",
  "Honey_1",
  "SpiderWeb_0",
  "Chains_0",
  "Chains_1",
  "Chains_2",
  "DarkClouds_2"
];

const EXTRA_CENTER_PIECES = Array.isArray(extraPieceCatalog?.centerPieces)
  ? extraPieceCatalog.centerPieces.filter((pieceId) => typeof pieceId === "string" && pieceId.trim())
  : [];

const BASE_CENTER_PIECES = [
  "Empty",
  "EmptyFall",
  "Spawner",
  "NoElement",
  "StartRandomElement",
  "RandomElement",
  "Blob_0",
  "Piece_Green",
  "Piece_Red",
  "Piece_Blue",
  "Piece_Yellow",
  "VerticalRune",
  "HorizontalRune",
  "Bomb",
  "SmartCannon",
  "Multicolor",
  "Teleporter",
  "BloodBag_0",
  "GoldBag_4",
  "WoodenBox_0",
  "WoodenBox_1",
  "WoodenBox_2",
  "SteelBox_0",
  "SteelBox_1",
  "SteelBox_2",
  "Bookcase_7",
  "TreasureMap_0",
  "Horse_0",
  "WateringCan_2",
  "Turtle_1",
  "CloverGarden_3",
  "Flower_1",
  "LeftDiagonalRune",
  "RightDiagonalRune",
  "Mine",
  "MulticolorGreen",
  "MulticolorBlue",
  "MulticolorYellow",
  "MulticolorRed",
  "ShipAnchor_0",
  "AlchemyBox_0",
  "AlchemyBox_1",
  "AlchemyBox_2",
  "AlchemyBox_3",
  "AlchemyBox_Breaker_0",
  "AlchemyBox_Breaker_1",
  "AlchemyBox_Breaker_2",
  "AlchemyBox_Breaker_3",
  "AlchemyBox_Fire_0",
  "AlchemyBox_Fire_1",
  "AlchemyBox_Fire_2",
  "AlchemyBox_Fire_3",
  "AlchemyBox_Trickster_0",
  "AlchemyBox_Trickster_1",
  "AlchemyBox_Trickster_2",
  "AlchemyBox_Trickster_3",
  "AlchemyBox_Summon_0",
  "AlchemyBox_Summon_1",
  "AlchemyBox_Summon_2",
  "AlchemyBox_Summon_3",
  "CursedBookSquare_4",
  "FishNet_3",
  "Worm_Hidden",
  "Worm_1",
  "Dolphin_0",
  "LavaBoulder_1",
  "LavaBall_0",
  "LavaBall_1",
  "Volcano_2",
  "MagicGemCore_4",
  "ElectricTower_0",
  "ChargeBattery_4",
  "Spider_0",
  "MagicalFruit_1",
  "WoodTotem_0",
  "WoodTotem_1",
  "WoodTotem_2",
  "WoodTotem_3",
  "WoodTotem_4",
  "WoodTotem_5",
  "WoodTotem_6",
  "WoodTotem_7",
  "WoodTotem_8",
  "Sphynx_5",
  "SarcophagusSquare_4",
  "CursedBookLT_4",
  "CursedBookFour_4",
  "CursedBookFive_4",
  "Tombstone_1",
  "SarcophagusLT_4",
  "SarcophagusFour_4",
  "SarcophagusFive_4",
  "MegaDragonBreathUp",
  "MegaDragonBreathDown",
  "MegaDragonBreathLeft",
  "MegaDragonBreathRight",
  "DragonBreathDown",
  "DragonBreathUp",
  "DragonBreathLeft",
  "DragonBreathRight",
  "Ice_0",
  "IceMetal_0",
  "Shelf_0",
  "LightSpark",
  "Spark",
  "MegaSpark",
  "LightningWish",
  "LightningStrike",
  "LightningStorm",
  "TopBoomerang",
  "BottomBoomerang",
  "LeftBoomerang",
  "RightBoomerang",
  "TopRightBoomerang",
  "TopLeftBoomerang",
  "BottomRightBoomerang",
  "BottomLeftBoomerang",
  "Cinders",
  "FireWish",
  "Flare",
  "Malik_Ghost",
  "Malik_Bone_Golem",
  "Malik_Skeleton",
  "Malik_Skull_Slime",
  "Malik_Skull_Big_Slime",
  "Malik_Bone_Naga",
  "Malik_Zombie",
  "Malik_Snake",
  "Malik_Necrotic_Egg",
  "Malik_Wall_One",
  "Malik_Wall_Four",
  "Malik_Wall_Nine",
  "Malik_Wall_One_Silver",
  "Malik_Skull_Slime_Weak",
  "Malik_Skull_Big_Slime_Weak"
];

export const CENTER_PIECES = [...BASE_CENTER_PIECES, ...EXTRA_CENTER_PIECES];

export const DEFAULT_BASIC_PIECES = [
  "Piece_Red",
  "Piece_Blue",
  "Piece_Yellow",
  "Piece_Green"
];

export const GAMEPLAY_TYPES = ["ThreatClear", "MalikFight"];

export const MULTI_TILE_SIZES = {
  Bookcase: [2, 2],
  Bookcase_0: [2, 2],
  Bookcase_1: [2, 2],
  Bookcase_2: [2, 2],
  Bookcase_3: [2, 2],
  Bookcase_4: [2, 2],
  Bookcase_5: [2, 2],
  Bookcase_6: [2, 2],
  Bookcase_7: [2, 2],
  Turtle: [1, 2],
  Turtle_0: [1, 2],
  Turtle_1: [1, 2],
  CloverGarden: [2, 2],
  CloverGarden_0: [2, 2],
  CloverGarden_1: [2, 2],
  CloverGarden_2: [2, 2],
  CloverGarden_3: [2, 2],
  CursedBookSquare: [2, 2],
  CursedBookSquare_0: [2, 2],
  CursedBookSquare_1: [2, 2],
  CursedBookSquare_2: [2, 2],
  CursedBookSquare_3: [2, 2],
  CursedBookSquare_4: [2, 2],
  LavaBoulder: [2, 2],
  LavaBoulder_0: [2, 2],
  LavaBoulder_1: [2, 2],
  Volcano: [3, 3],
  Volcano_0: [3, 3],
  Volcano_1: [3, 3],
  Volcano_2: [3, 3],
  ElectricTower: [3, 1],
  ElectricTower_0: [3, 1],
  ChargeBattery: [2, 1],
  ChargeBattery_0: [2, 1],
  ChargeBattery_1: [2, 1],
  ChargeBattery_2: [2, 1],
  ChargeBattery_3: [2, 1],
  ChargeBattery_4: [2, 1],
  WoodTotem: [3, 2],
  WoodTotem_0: [3, 2],
  WoodTotem_1: [3, 2],
  WoodTotem_2: [3, 2],
  WoodTotem_3: [3, 2],
  WoodTotem_4: [3, 2],
  WoodTotem_5: [3, 2],
  WoodTotem_6: [3, 2],
  WoodTotem_7: [3, 2],
  WoodTotem_8: [3, 2],
  Sphynx: [3, 4],
  Sphynx_0: [3, 4],
  Sphynx_1: [3, 4],
  Sphynx_2: [3, 4],
  Sphynx_3: [3, 4],
  Sphynx_4: [3, 4],
  Sphynx_5: [3, 4],
  SarcophagusSquare: [3, 1],
  SarcophagusSquare_0: [3, 1],
  SarcophagusSquare_1: [3, 1],
  SarcophagusSquare_2: [3, 1],
  SarcophagusSquare_3: [3, 1],
  SarcophagusSquare_4: [3, 1],
  CursedBookLT: [2, 2],
  CursedBookLT_0: [2, 2],
  CursedBookLT_1: [2, 2],
  CursedBookLT_2: [2, 2],
  CursedBookLT_3: [2, 2],
  CursedBookLT_4: [2, 2],
  CursedBookFour: [2, 2],
  CursedBookFour_0: [2, 2],
  CursedBookFour_1: [2, 2],
  CursedBookFour_2: [2, 2],
  CursedBookFour_3: [2, 2],
  CursedBookFour_4: [2, 2],
  CursedBookFive: [2, 2],
  CursedBookFive_0: [2, 2],
  CursedBookFive_1: [2, 2],
  CursedBookFive_2: [2, 2],
  CursedBookFive_3: [2, 2],
  CursedBookFive_4: [2, 2],
  SarcophagusLT: [3, 1],
  SarcophagusLT_0: [3, 1],
  SarcophagusLT_1: [3, 1],
  SarcophagusLT_2: [3, 1],
  SarcophagusLT_3: [3, 1],
  SarcophagusLT_4: [3, 1],
  SarcophagusFour: [3, 1],
  SarcophagusFour_0: [3, 1],
  SarcophagusFour_1: [3, 1],
  SarcophagusFour_2: [3, 1],
  SarcophagusFour_3: [3, 1],
  SarcophagusFour_4: [3, 1],
  SarcophagusFive: [3, 1],
  SarcophagusFive_0: [3, 1],
  SarcophagusFive_1: [3, 1],
  SarcophagusFive_2: [3, 1],
  SarcophagusFive_3: [3, 1],
  SarcophagusFive_4: [3, 1],
  FishNet: [2, 2],
  FishNet_0: [2, 2],
  FishNet_1: [2, 2],
  FishNet_2: [2, 2],
  FishNet_3: [2, 2],
  Malik_Bone_Golem: [2, 2],
  Malik_Skeleton: [1, 2],
  Malik_Skull_Slime: [2, 2],
  Malik_Skull_Big_Slime: [3, 2],
  Malik_Bone_Naga: [3, 2],
  Malik_Necrotic_Egg: [2, 2],
  Malik_Wall_Four: [4, 1],
  Malik_Wall_Nine: [9, 1],
  Malik_Skull_Slime_Weak: [2, 2],
  Malik_Skull_Big_Slime_Weak: [3, 2]
};

const ALL_KNOWN = new Set([
  ...BACKGROUND_PIECES,
  ...CENTER_PIECES,
  ...FOREGROUND_PIECES,
  ...Object.keys(MULTI_TILE_SIZES),
  "PartOf",
  "Empty",
  "NoElement",
  "RandomElement"
]);

export function getPaletteForLayer(layer, { includeInactive = false } = {}) {
  let palette = CENTER_PIECES;
  if (layer === LAYER.BACKGROUND) {
    palette = BACKGROUND_PIECES;
  } else if (layer === LAYER.FOREGROUND) {
    palette = FOREGROUND_PIECES;
  }

  return includeInactive ? palette : palette.filter((pieceType) => isPieceActive(pieceType));
}

export function normalizePieceType(value, fallback = "Empty") {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (!trimmed) return fallback;
  return ALL_KNOWN.has(trimmed) ? trimmed : fallback;
}

export function isLayerPieceValid(layer, pieceType) {
  return getPaletteForLayer(layer, { includeInactive: true }).includes(pieceType);
}

export function getPieceSize(pieceType) {
  const configuredSize = getConfiguredPieceSize(pieceType);
  if (configuredSize) {
    return configuredSize;
  }

  const size = MULTI_TILE_SIZES[pieceType];
  if (!size) return { width: 1, height: 1 };
  return { width: size[0], height: size[1] };
}
